import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';

function DiagramError({ error, mermaidCode, renderCustomError, t }) {
  // Si hay un renderizador personalizado, usarlo
  if (renderCustomError) {
    const customErrorHTML = renderCustomError(error, mermaidCode);
    return <div dangerouslySetInnerHTML={{ __html: customErrorHTML }} />;
  }

  // Renderizar error por defecto
  return (
    <div className="diagram-mermaid-error">
      <div className="diagram-mermaid-error__container">
        <div className="diagram-mermaid-error__icon">
          <Icon name="caution-outline" />
        </div>
        <div className="diagram-mermaid-error__message">{t('chatbot:Error rendering diagram')}</div>
      </div>
      {mermaidCode && (
        <details className="diagram-mermaid-error__details">
          <summary>{t('chatbot:View source code')}</summary>
          <div className="diagram-mermaid-error__code">
            <p>{error?.message}</p>
            <pre>
              <code>{mermaidCode}</code>
            </pre>
          </div>
        </details>
      )}
    </div>
  );
}

DiagramError.propTypes = {
  error: PropTypes.object,
  mermaidCode: PropTypes.string,
  renderCustomError: PropTypes.func,
  t: PropTypes.func,
};

DiagramError.defaultProps = {
  error: null,
  mermaidCode: '',
  renderCustomError: null,
  t: () => '',
};

export default DiagramError;
